export default __webpack_public_path__ + "static/media/medical-3.538564b9.jpg";